// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Logo-module-logo-1yvQe{display:block;width:50px;height:50px;position:relative}@media(min-width: 960px){.Logo-module-logo-1yvQe{width:75px;height:75px}}.Logo-module-image-31Zp8{width:100%;height:100%}", ""]);
// Exports
exports.locals = {
	"logo": "Logo-module-logo-1yvQe",
	"image": "Logo-module-image-31Zp8"
};
module.exports = exports;
